import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import forms from 'constants/forms';
import Input from 'components/atoms/input';
import dataService from 'services/dataService';
import { apiGetClinicByGuid } from 'services/dataService/resources';
import loadClinicOptions from 'utils/loadClinicOptions';

const Clinic = ({ errors, getDoctors, values }) => {
  const clinicForm = [...forms.adminPanelsUser.userEdit.clinic];

  // The dropdown is fed by `core/clinics/select-options`, which returns only
  // guid/legalname. Address details are fetched for the picked clinic only.
  const fillClinicAddress = async (clinicGuid, setFieldValue) => {
    const { data, error } = await dataService.getOnly(
      apiGetClinicByGuid(clinicGuid),
    );

    setFieldValue('clinicAddress', (!error && data?.addressLine1) || '');
    setFieldValue('clinicState', (!error && data?.state) || '');
    setFieldValue('clinicCity', (!error && data?.city) || '');
  };

  return (
    <div className="admin-patient-form-block">
      <span>Clinic</span>
      <Row>
        <Col lg="6" md="6" sm="6" xs="12">
          <Input
            dataCy="clinic-name-input"
            label="Clinic"
            id="clinicGuid"
            type="asyncselect"
            loadOptions={loadClinicOptions}
            onChange={async (e, setFieldValue) => {
              if (!e?.id) return;

              await fillClinicAddress(e.id, setFieldValue);

              getDoctors({
                clinicGuid: e.id,
                filter: {
                  roleName:
                    'doctor,nursePractitioner,registeredNurse,physicianAssistant,pharmD,medicalAssistant',
                },
              });
            }}
          />
          {!values?.clinicGuid && errors.clinicGuid ? (
            <div className="input-error">{errors.clinicGuid}</div>
          ) : null}
        </Col>
        {clinicForm.map((field) => (
          <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
            <Input {...field} disabled />
            {errors[field.id] ? (
              <div className="input-error">{errors[field.id]}</div>
            ) : null}
          </Col>
        ))}
      </Row>
    </div>
  );
};

Clinic.propTypes = {
  errors: PropTypes.shape(),
  values: PropTypes.shape(),
  getDoctors: PropTypes.func.isRequired,
};

export default Clinic;
